<template>
  <div class="print-labels--content">
    <h3>Поля, которые будут включены в выгрузку</h3>
    <div class="print-labels--flex">
      <div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="time"
                v-model="enrollFields.time"
            />
            Время записи
          </label>
        </div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="services"
                v-model="enrollFields.services"
            />
            Услуги
          </label>
        </div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="enroll_price"
                v-model="enrollFields.enroll_price"
            />
            Общая стоимость записи
          </label>
        </div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="company_comment"
                v-model="enrollFields.company_comment"
            />
            Ваши комментарии
          </label>
        </div>
      </div>
      <div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="client_name"
                v-model="enrollFields.client_name"
            />
            ФИО клиента
          </label>
        </div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="client_phone"
                v-model="enrollFields.client_phone"
            />
            Номер клиента
          </label>
        </div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="client_comment"
                v-model="enrollFields.client_comment"
            />
            Комментарии клиента
          </label>
        </div>
      </div>
    </div>
    <h3>С какими статусами выгружать записи</h3>
    <div class="print-labels--flex">
      <div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="status_new"
                v-model="statuses[0]"
            />
            Новая
          </label>
        </div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="status_confirm"
                v-model="statuses[1]"
            />
            Подтвержденная
          </label>
        </div>
      </div>
      <div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="status_done"
                v-model="statuses[2]"
            />
            Завершенная
          </label>
        </div>
        <div class="input-block">
          <label>
            <input
                type="checkbox"
                id="status_canceled"
                v-model="statuses[3]"
            />
            Отмененная
          </label>
        </div>
      </div>
    </div>
    <h3>Дата выгрузки</h3>
    <div class="input-block">
      <DatePicker
          v-model="dateModel"
          :value="dateModel"
      ></DatePicker>
    </div>
    <h3>Список сотрудников, для которых будет сформирована выгрузка</h3>
    <div class="input-block">
      <simple-select
          :data="staff_list"
          :reset="show"
          @changeValue="changeStaffSelect"
      ></simple-select>
    </div>
    <div class="input-block">
      <div @click="generateFile" class="btn btn-sm btn-success">Сформировать файл</div>
    </div>
    <div v-if="fileLink" class="mrg-t-20 alert alert-sm alert-success">
      <p>Файл сгенерирован! Ссылка для скачивания: </p>
      <p><a style="font-weight: 700; text-decoration: underline" :href="fileLink">{{fileLink}}</a></p>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker";
import SimpleSelect from "@/components/SimpleSelect";
import journalRepository from "../../../repositories/journal";

export default {
  name: "PrintLabels",
  components: {SimpleSelect, DatePicker},
  data() {
    return {
      enrollFields: {
        time: true,
        client_name: true,
        services: true,
        client_phone: false,
        enroll_price: false,
        client_comment: false,
        company_comment: false
      },
      statuses: [true, true, true, false],
      dateModel: "",
      staffSelect: [],
      fileLink: null
    };
  },
  props: {
    staff_list: Array,
    show: Boolean
  },
  watch: {
    show: function(val){
      if(!val){
        this.fileLink = null;
        this.dateModel = '';
        this.staffSelect = [];
      }
    }
  },
  computed: {

  },
  methods: {
    changeStaffSelect(val){
      this.staffSelect = val;
    },
    generateFile(){
      this.$store.dispatch("startPreloader");
      const data = {
        fields: JSON.stringify(this.enrollFields),
        date: this.dateModel,
        staff_list: this.staffSelect.join(',')
      };

      let statuses = [];
      for(let i = 0; i <= 3; i++){
        if(this.statuses[i]){
          statuses[statuses.length] = i;
        }
      }
      data.statuses = JSON.stringify(statuses);

      journalRepository.printLabels(data).then(resp => {
        if(resp.data.result === 'ok'){
          this.fileLink = resp.data.link;
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("stopPreloader");
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    }
  },
  created() {}
};
</script>

<style scoped lang="less">
.print-labels--flex{
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  flex-direction: row;

  &>div{
    width: 49%;
  }
}
</style>
